"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.minHeightBreakpoint = exports.minWidthBreakpoint = exports.breakpointValues = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (max-width: ", "em) {\n      ", "\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      @media (min-height: ", "em) {\n        ", "\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      @media (min-width: ", "em) {\n        ", "\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var breakpointValues = {
  hd: 1920,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  phoneLarge: 680,
  phone: 500
};
exports.breakpointValues = breakpointValues;
var minWidthBreakpoint = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject(), (breakpointValues[label] + 1) / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.minWidthBreakpoint = minWidthBreakpoint;
var minHeightBreakpoint = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject2(), breakpointValues[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.minHeightBreakpoint = minHeightBreakpoint;

var _default = Object.keys(breakpointValues).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject3(), breakpointValues[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/responsiveBreakpoints.js
// module id = 20
// module chunks = 5 6 7